import { configuratorType } from "./model"

export function getConfiguratorTrackingString(value: configuratorType) {
    switch (value) {
        case "images":
            return "branding & ads"
        default:
            return value
    }
}
